import { SITE } from '@/app/constants';

export const CLAW_ICON_IMAGE_URL =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/vidu-claw-icon-img-2-5666b396.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/vidu-claw-icon-img-2-5666b396.webp';

export const agentProjectPageBg =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/agent-project-list-bg-img-eaddf391.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/agent-project-list-bg-img-eaddf391.webp';

// 推荐标签,  =>  获取agentLibraryProjectTagList中所有tag的数据
export const RECOMMEND_TAG = {
  key: 'recommend',
  zh_title: '推荐',
  en_title: 'Recommend',
};

const agentLibraryProjectTagList = [
  {
    key: 'apparel_footwear',
    zh_title: '服饰鞋包',
    en_title: 'Apparel',
  },
  {
    key: 'health',
    zh_title: '健康保健',
    en_title: 'Health',
  },
  {
    key: 'beauty',
    zh_title: '美妆护肤',
    en_title: 'Beauty',
  },
  {
    key: 'food_fresh',
    zh_title: '食品生鲜',
    en_title: 'Food',
  },
  {
    key: 'electronics',
    zh_title: '电子产品',
    en_title: 'Consumer Electronics',
  },
  {
    key: 'daily_household',
    zh_title: '日用品',
    en_title: 'Commodities',
  },
  {
    key: 'home_appliances',
    zh_title: '家电',
    en_title: 'Appliances',
  },
];

export const getAgentLibraryProjectTags = (locale: string) => {
  const recommendTag = agentLibraryProjectTagList.map((item) => item.key).join(',');
  return [
    {
      key: recommendTag,
      title: locale === 'zh' ? RECOMMEND_TAG.zh_title : RECOMMEND_TAG.en_title,
    },
    ...agentLibraryProjectTagList.map((item) => ({
      key: item.key,
      title: locale === 'zh' ? item.zh_title : item.en_title,
    })),
  ];
};
